import { useEffect, useState } from "react";

/** Доля, а не пиксели: порог привязан к первому экрану на любом устройстве */
export const useScrolledPast = (viewportRatio = 0.65) => {
  const [isPast, setIsPast] = useState(false);

  useEffect(() => {
    let frame = 0;

    const update = () => {
      frame = 0;
      setIsPast(window.scrollY > window.innerHeight * viewportRatio);
    };

    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };

    // Первый замер тоже через кадр: страницу могли открыть уже прокрученной
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [viewportRatio]);

  return isPast;
};
